import { Injectable } from '@angular/core';
import { ActiveDirectorySearch } from "../../shared/models/activeSearch";

const mockActiveSearchData = {
  "totalCount": 20,
  "items": [
    {
      "firstName": "ROGER",
      "middleName": "H",
      "lastName": "HECHT",
      "suffix": null,
      "line1": "1624 NORWOOD ST",
      "line2": null,
      "line3": null,
      "city": "EUGENE",
      "stateProvince": "OR",
      "zip": "97401",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "RRT",
          "certificationDate": "1981-11-21T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "CPFT",
          "certificationDate": "1984-12-01T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "MATT",
      "middleName": "J",
      "lastName": "CRAWFORD",
      "suffix": null,
      "line1": "334 LIONGATE ST",
      "line2": null,
      "line3": null,
      "city": "ATLANTA",
      "stateProvince": "GA",
      "zip": "11223",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
      ]
    },
    {
      "firstName": "TRAVIS",
      "middleName": "H",
      "lastName": "BARKER",
      "suffix": null,
      "line1": "123 BROKE ST",
      "line2": "SAWGRASS VILLAGES",
      "line3": "APT 4 - 501",
      "city": "MIAMI",
      "stateProvince": "FL",
      "zip": "01011",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "RRT",
          "certificationDate": "1981-11-21T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "CPFT",
          "certificationDate": "1984-12-01T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "JAMES",
      "middleName": "L",
      "lastName": "HETFIELD",
      "suffix": null,
      "line1": "5988 EAGLE ST",
      "line2": "EL DORADO RESIDENCES",
      "line3": null,
      "city": "SAN FRANCISCO",
      "stateProvince": "CA",
      "zip": "99887",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "CPFT",
          "certificationDate": "1984-12-01T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "SHELLEY",
      "middleName": "A",
      "lastName": "HECHT",
      "suffix": null,
      "line1": "22204 WEST 52ND STREET",
      "line2": null,
      "line3": "SHAWNEE",
      "city": "SHAWNEE",
      "stateProvince": "KS",
      "zip": "66226",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "2014-01-09T00:00:00",
          "expirationDate": "2019-01-31T00:00:00"
        },
        {
          "credentialCode": "RRT",
          "certificationDate": "2014-01-30T00:00:00",
          "expirationDate": "2019-01-31T00:00:00"
        }
      ]
    },
    {
      "firstName": "MARY",
      "middleName": "H",
      "lastName": "HUMBOLDT",
      "suffix": null,
      "line1": "1624 NORWOOD ST",
      "line2": null,
      "line3": null,
      "city": "EUGENE",
      "stateProvince": "OR",
      "zip": "97401",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "RRT",
          "certificationDate": "1981-11-21T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "JOHN",
      "middleName": "J",
      "lastName": "LUKE",
      "suffix": null,
      "line1": "334 LIONGATE ST",
      "line2": null,
      "line3": null,
      "city": "ATLANTA",
      "stateProvince": "GA",
      "zip": "11223",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
      ]
    },
    {
      "firstName": "PETER",
      "middleName": "H",
      "lastName": "PARKER",
      "suffix": null,
      "line1": "123 BROKE ST",
      "line2": "SAWGRASS VILLAGES",
      "line3": "APT 4 - 501",
      "city": "MIAMI",
      "stateProvince": "FL",
      "zip": "01011",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "RRT",
          "certificationDate": "1981-11-21T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "CPFT",
          "certificationDate": "1984-12-01T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "KIRK",
      "middleName": "L",
      "lastName": "HAMMETT",
      "suffix": null,
      "line1": "5988 EAGLE ST",
      "line2": "EL DORADO RESIDENCES",
      "line3": null,
      "city": "SAN FRANCISCO",
      "stateProvince": "CA",
      "zip": "99887",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "CPFT",
          "certificationDate": "1984-12-01T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "DAVE",
      "middleName": "A",
      "lastName": "GROHL",
      "suffix": null,
      "line1": "22204 WEST 52ND STREET",
      "line2": null,
      "line3": "SHAWNEE",
      "city": "SHAWNEE",
      "stateProvince": "KS",
      "zip": "66226",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "2014-01-09T00:00:00",
          "expirationDate": "2019-01-31T00:00:00"
        },
        {
          "credentialCode": "RRT",
          "certificationDate": "2014-01-30T00:00:00",
          "expirationDate": "2019-01-31T00:00:00"
        }
      ]
    },
    {
      "firstName": "JON",
      "middleName": "H",
      "lastName": "HECHT",
      "suffix": null,
      "line1": "123 MILE ST",
      "line2": null,
      "line3": null,
      "city": "EUGENE",
      "stateProvince": "OR",
      "zip": "11",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "RRT",
          "certificationDate": "1981-11-21T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "CPFT",
          "certificationDate": "1984-12-01T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "MARY",
      "middleName": "J",
      "lastName": "SANZ",
      "suffix": null,
      "line1": "333 SEATURTLE ST",
      "line2": null,
      "line3": null,
      "city": "ATLANTA",
      "stateProvince": "GA",
      "zip": "12",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
      ]
    },
    {
      "firstName": "LARS",
      "middleName": "H",
      "lastName": "WATFORD",
      "suffix": null,
      "line1": "098 FILL ST",
      "line2": "SAWGRASS VILLAGES",
      "line3": "APT 4 - 501",
      "city": "MIAMI",
      "stateProvince": "FL",
      "zip": "13",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "RRT",
          "certificationDate": "1981-11-21T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "CPFT",
          "certificationDate": "1984-12-01T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "ALVARO",
      "middleName": "L",
      "lastName": "BUSTAMANTE",
      "suffix": null,
      "line1": "567 PINKBIRD ST",
      "line2": "EL DORADO RESIDENCES",
      "line3": null,
      "city": "SAN FRANCISCO",
      "stateProvince": "CA",
      "zip": "14",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "CPFT",
          "certificationDate": "1984-12-01T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "MATHIAS",
      "middleName": "A",
      "lastName": "SAMMER",
      "suffix": null,
      "line1": "678 EAST STREET",
      "line2": null,
      "line3": "SHAWNEE",
      "city": "SHAWNEE",
      "stateProvince": "KS",
      "zip": "15",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "2014-01-09T00:00:00",
          "expirationDate": "2019-01-31T00:00:00"
        },
        {
          "credentialCode": "RRT",
          "certificationDate": "2014-01-30T00:00:00",
          "expirationDate": "2019-01-31T00:00:00"
        }
      ]
    },
    {
      "firstName": "OMAR",
      "middleName": "H",
      "lastName": "HAGOPIAN",
      "suffix": null,
      "line1": "432 VALLEY ST",
      "line2": null,
      "line3": null,
      "city": "EUGENE",
      "stateProvince": "OR",
      "zip": "16",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "RRT",
          "certificationDate": "1981-11-21T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "JOSEPH",
      "middleName": "J",
      "lastName": "GORDON",
      "suffix": null,
      "line1": "7898 FREEMAN ST",
      "line2": null,
      "line3": null,
      "city": "ATLANTA",
      "stateProvince": "GA",
      "zip": "17",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
      ]
    },
    {
      "firstName": "JOHN",
      "middleName": "H",
      "lastName": "MAYER",
      "suffix": null,
      "line1": "77665 INDIANA ST",
      "line2": "SAWGRASS VILLAGES",
      "line3": "APT 4 - 501",
      "city": "MIAMI",
      "stateProvince": "FL",
      "zip": "18",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "RRT",
          "certificationDate": "1981-11-21T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "CPFT",
          "certificationDate": "1984-12-01T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "RANDY",
      "middleName": "L",
      "lastName": "JONES",
      "suffix": null,
      "line1": "0023 ARIZONA ST",
      "line2": "EL DORADO RESIDENCES",
      "line3": null,
      "city": "SAN FRANCISCO",
      "stateProvince": "CA",
      "zip": "19",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "1977-06-04T00:00:00",
          "expirationDate": null
        },
        {
          "credentialCode": "CPFT",
          "certificationDate": "1984-12-01T00:00:00",
          "expirationDate": null
        }
      ]
    },
    {
      "firstName": "PAT",
      "middleName": "A",
      "lastName": "SMEAR",
      "suffix": null,
      "line1": "789 CALIFORNIA STREET",
      "line2": null,
      "line3": "SHAWNEE",
      "city": "SHAWNEE",
      "stateProvince": "KS",
      "zip": "20",
      "country": null,
      "directoryStatus": "F",
      "provisional": false,
      "certifications": [
        {
          "credentialCode": "CRT",
          "certificationDate": "2014-01-09T00:00:00",
          "expirationDate": "2019-01-31T00:00:00"
        },
        {
          "credentialCode": "RRT",
          "certificationDate": "2014-01-30T00:00:00",
          "expirationDate": "2019-01-31T00:00:00"
        }
      ]
    }
  ]
};

@Injectable()
export class DirectoryMocksService {
  activeSearch:ActiveDirectorySearch = mockActiveSearchData;

  getActiveSearch(offset: number): any {
    let auxActiveSearch = Object.assign({}, this.activeSearch);
    if (offset < 10)
      auxActiveSearch.items = mockActiveSearchData.items.slice(0, 10);
    else
      auxActiveSearch.items = mockActiveSearchData.items.slice(10);
    return ( {body: auxActiveSearch, status: 200, headers: null, url: '', merge: null});
  }
}
